import { Box, MenuItem } from '@mui/material';
import { CustomButton, CustomSelect, HeaderFilterBox } from '../../../common/components';

const LastInvoiceFilters = ({
  salePoints,
  salePoint,
  setSalePoint,
  voucherType,
  setVoucherType,
  onSearch,
  isLoading,
}) => {
  return (
    <HeaderFilterBox variant="oneRow">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <CustomSelect
          label="Punto de Venta"
          labelId="last-invoice-sale-point-label"
          id="last-invoice-sale-point-select"
          value={salePoint}
          onChange={(e) => setSalePoint(e.target.value)}
          displayEmpty
          disabled={isLoading}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">
            Seleccionar
          </MenuItem>
          {salePoints.map((sp) => (
            <MenuItem key={sp.uuid ?? sp.number} value={sp.number}>
              {sp.number}
            </MenuItem>
          ))}
        </CustomSelect>
        <CustomSelect
          label="Tipo de Comprobante"
          labelId="last-invoice-type-label"
          id="last-invoice-type-select"
          value={voucherType}
          onChange={(e) => setVoucherType(Number(e.target.value))}
          disabled={isLoading}
          sx={{ minWidth: 220 }}
        >
          <MenuItem value={6}>Factura B</MenuItem>
        </CustomSelect>
        <CustomButton
          variant="base"
          color="primary"
          onClick={onSearch}
          disabled={isLoading || !salePoint}
        >
          Consultar última factura
        </CustomButton>
      </Box>
    </HeaderFilterBox>
  );
};

export default LastInvoiceFilters;
